import { withSvgIcon } from './withSvgIcon';

export const WarningSolidIcon = withSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0831 2.6129C12.6017 1.7957 11.3983 1.7957 10.9169 2.6129L1.16942 19.1613C0.688056 19.9785 1.28975 21 2.25247 21H21.7475C22.7102 21 23.3119 19.9785 22.8306 19.1613L13.0831 2.6129ZM10.5704 7.25991C10.5523 7.04291 10.7235 6.85681 10.9413 6.85681H13.0849C13.3026 6.85681 13.4739 7.04291 13.4558 7.25991L12.8975 13.9593C12.8814 14.1522 12.7202 14.3005 12.5266 14.3005H11.4995C11.306 14.3005 11.1447 14.1522 11.1286 13.9593L10.5704 7.25991ZM13.4887 17.3642C13.4887 18.1864 12.8222 18.8529 12 18.8529C11.1778 18.8529 10.5113 18.1864 10.5113 17.3642C10.5113 16.542 11.1778 15.8755 12 15.8755C12.8222 15.8755 13.4887 16.542 13.4887 17.3642Z"
      fill="#EEA941" />
  </>,
  { viewBox: '0 0 24 24' },
);
